var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb mb-0"},[_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Card")]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_vm._v(_vm._s(_vm.$route.meta.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1fe9958","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcumb.vue
// module id = inpP
// module chunks = 1